export default __webpack_public_path__ + "images/ES.8acbf9e.png";